import React, { Component } from "react";
import StackedOrderedBox from './components/StackedOrderedBox'
import { graphql, compose } from "react-apollo";
import { 
  queryGetAverageResponseRate, 
  queryGetAverageResponseRateWithinSLA 
} from "Apollo";
import { GetAnalyticFilter } from "Store";
import { observer } from "mobx-react";

const gqlOptions = {
  options: {
    fetchPolicy: "network-only"
  }
};

const Box = compose(
  graphql(queryGetAverageResponseRate, { ...gqlOptions, name: "noSla"}),
  graphql(queryGetAverageResponseRateWithinSLA, { ...gqlOptions, name: "withinSla" })
)(
  class ResponseRateSummary extends Component {
    render() {
      const { 
        noSla, withinSla
       } = this.props;
      let averageValue = 0;
      let streamCount = 0;
      let averageValueWithinSLA = 0;

      if (!noSla.loading && noSla.getAverageResponseRate) {
        if (noSla.getAverageResponseRate.data[0]) {
          let item = noSla.getAverageResponseRate.data[0];
          averageValue = item.value;
          streamCount = item.details.find(
            itemDetail => itemDetail.name === "incoming_count"
          ).value;
        }
      }
      if (!withinSla.loading && withinSla.getAverageResponseRateWithinSLA) {
        if (withinSla.getAverageResponseRateWithinSLA.data[0]) {
          let item = withinSla.getAverageResponseRateWithinSLA.data[0];
          averageValueWithinSLA = item.value;          
        }
      }
      const opt = {
        size: "large",
        contentList: [
          {
            title: "Response Rate within SLA",
            content: averageValueWithinSLA.toFixed(1) + " %",
            footer: {
              text: streamCount + " streams"
            }
          },
          {
            title: "Response Rate",
            content: averageValue.toFixed(1) + " %",
            footer: {
              text: streamCount + " streams"
            }
          }
        ]
      };
      return <StackedOrderedBox {...opt} />;
    }
  }
);

export default observer(
  class BoxWithQuery extends Component {
    render() {
      return <Box {...GetAnalyticFilter()} />;
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-analytics/ResponseRateSummary.js